import React from 'react';
//import s from './Wps.module.scss';
import Button from '@mui/material/Button';

import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const Wspbutton = () => {
	const defaultMessage = "Hola, tengo una consulta!!";
    const encodedMessage = encodeURIComponent(defaultMessage);
    const phoneNumber = "+5492236223282";
    const whatsappLink = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;


	return (
		
		
			<Button  
				variant="contained"
				href={whatsappLink}
				startIcon={<WhatsAppIcon />} 
				target="_blank"
            	rel="noopener noreferrer"
				style={{
					borderRadius: '10px', 
					padding: '10px 20px',
					backgroundColor: '#df0e3d',
					color: '#EEEEEE',
					position: 'fixed',
					zIndex: '999',
					top: '87%',    // Ajusta el margen superior en porcentaje
					left: 'calc(100% - 360px)',   // Ajusta el margen izquierdo en porcentaje
					height: '3.1rem', // Tamaño fijo del botón
					width: 'auto',
				}}
			>
				Chatea con nosotros
			</Button>
	)
}

export default Wspbutton;